import styled from "styled-components"
import { TableCell } from "./TableCell"
import { TableHeaderCell } from "./TableHeaderCell"
import type { RowProps } from "./types"

export interface TableRowProps {
  rowProps?: RowProps
}

export const TableRow = styled.tr<TableRowProps>`
  box-sizing: border-box;
  border: none;
  outline: none;
  background: #fff;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray90};
  ${(props) =>
    props.rowProps?.summation &&
    `
    ${TableCell} {
      background: ${props.theme.colors.primary};
      font-weight: bold;
    }
  `}
  ${(props) =>
    props.rowProps?.disabled &&
    `
      color: ${props.theme.colors.gray60};  
      background-color: ${props.theme.colors.gray80};
    }
    `}
    
  ${(props) =>
    props.rowProps?.striped &&
    `
    :nth-of-type(2n + 1){
      background: rgba(0, 0, 0, 0.025);
    }
  `}

  ${(props) =>
    !props.rowProps?.head &&
    !props.rowProps?.noHover &&
    `
    :hover {
      background: #f9f9f9;
      color: ${props.theme.colors.primary};
    }
  `}

  :last-of-type {
    ${TableCell} {
      border-bottom: none;
    }
  }

  ${TableHeaderCell} {
    border-bottom: 2px solid ${(props) => props.theme.colors.gray80};
  }
`
